import { dataAttribute, DataAttributes, FontIcon, Stack } from "@bps/fluent-ui";
import { CalendarEventType } from "@libs/gateways/booking/BookingGateway.dtos.ts";

import { BigCalendarEvent } from "./BookingCalendarEvent.types.ts";
import { getSettledIcon } from "./BookingCalendarEvent.utils.ts";

interface BookingCalendarEventIconProps {
  event: BigCalendarEvent;
}

export const BookingCalendarEventIcons: React.FC<
  BookingCalendarEventIconProps
> = ({ event }) => {
  const { settlementStatus } = event.model;

  const showRecurrenceIcon =
    event.calendarEventRecurrenceId !== undefined &&
    (event.type === CalendarEventType.Unavailable ||
      event.type === CalendarEventType.Appointment);

  if (event.model.noChargeComment && !showRecurrenceIcon && !settlementStatus) {
    return null;
  }
  return (
    <Stack.Item shrink={false}>
      <Stack
        horizontal
        tokens={{ childrenGap: 8 }}
        styles={{ root: { paddingTop: 3 } }}
      >
        {settlementStatus && (
          <FontIcon
            {...dataAttribute(
              DataAttributes.Element,
              `${settlementStatus}-icon`
            )}
            iconName={getSettledIcon(settlementStatus)}
            styles={{ root: { fontSize: 12 } }}
          />
        )}
        {showRecurrenceIcon && (
          <FontIcon
            {...dataAttribute(
              DataAttributes.Element,
              event.isPartOfRecurrence
                ? "is-part-of-recurrence-icon"
                : "is-not-part-of-recurrence-icon"
            )}
            iconName={
              event.isPartOfRecurrence ? "SyncOccurence" : "UnsyncOccurence"
            }
          />
        )}
        {event.model.calendarEventExtension?.openEncounters &&
          event.model.calendarEventExtension.openEncounters.length > 0 && (
            <FontIcon iconName="EditNote" />
          )}
      </Stack>
    </Stack.Item>
  );
};
